import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { ImageIndividual } from '../models/imageIndividual';
import { WriteOrdinalSuffixOfNumber } from 'starbase-launcher';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { ImageTypes } from '../models/imageType';
import { DataDisplayerBase } from '../data-displayer-base';
import { BreakpointService } from '../breakpoint.service';

@Component({
  selector: 'app-individuals-display',
  templateUrl: './individuals-display.component.html',
  styleUrls: ['./individuals-display.component.css']
})
export class IndividualsDisplayComponent extends DataDisplayerBase<ImageIndividual> implements OnChanges {
  @Input() typeOfImageId: ImageTypes;
  @Input() editable = false;
  @Input() searchText: string;
  @Input() totalRecords: number;

  @Output() editRow: EventEmitter<ImageIndividual> = new EventEmitter<ImageIndividual>();
  @Output() handleEndOfData: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('notesModal', { static: true }) notesModal: TemplateRef<any>;
  @ViewChild('moreInfo', {static: true }) moreInfoSubSection: TemplateRef<any>;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  ImageTypes = ImageTypes;

  writeOrdinalSuffix = WriteOrdinalSuffixOfNumber;

  selectedItem: ImageIndividual;

  notesToEmbolden: string;
  isUpdateDataRequestSent = false;
  page = 1;
  isHandset: boolean = false;

  private rpp = 100; // must match the server's setting on parent component's data service
  private moreInfoModal: StarbaseModalOptions;
  private _subscription;

  constructor(private modalSvc: StarbaseModalDialogService,
              private breakpointSvc: BreakpointService) {
    super();
  }

  ngOnInit() {
    this._subscription = this.breakpointSvc.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      })

    if (this.isHandset) {
      this.columns = this.columns.slice(0,4);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    ImageIndividual.setupCollection(this.data);
  }
  seeMoreText(k: ImageIndividual) {
    /* eslint-disable curly */
    if (!k.notes) return;
    if (k.notes.length < 13) return;
    k = new ImageIndividual().deserialize(k);
    this.notesToEmbolden = k.notes;
    this.modalSvc.postModal(new StarbaseModalOptions(
      'Notes for ' + k.displayName(),
      undefined,
      [],
      undefined,
      this.notesModal
    ));
  }

  isRankShown(){
    return this.selectedItem.currentRankInPhoto === true ? " YES" : " NO"
  }

  onRowClick(item: ImageIndividual): void {
    this.selectedItem = item;
    item = new ImageIndividual().deserialize(item);
    this.notesToEmbolden = item.notes;

    this.moreInfoModal = new StarbaseModalOptions(
      `${this.selectedItem.firstName} ${this.selectedItem.lastName}`,
      '',
      [
        new StarbaseModalButton(
          'Okay', () => {
            this.modalSvc.closeModal('User clicked okay.');
          })
      ],
      StarbaseModalTypes.Info,
      this.moreInfoSubSection);
      this.moreInfoModal.forcedWidth =   this.isHandset ? "95vw" : "55%";
      this.moreInfoModal.forcedHeight = "55vh";
    
      this.modalSvc.postModal(this.moreInfoModal);
  }

  checkIfTextContainsSearchTerm(k: ImageIndividual): boolean {
    if (!this.searchText) return false;
    const terms = this.searchText.split(' ');
    if (terms.some(s => k.firstName.toLowerCase().includes(s))) {
      return true;
    }
    if (terms.some(s => k.lastName.toLowerCase().includes(s))) {
      return true;
    }
    if (terms.some(s => k.notes.toLowerCase().includes(s))) {
      return true;
    }
    return false;
  }

  onScroll(event: any) {
    // eslint-disable-next-line max-len
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - event.target.offsetHeight && this.data.length % this.rpp === 0 && !this.isUpdateDataRequestSent) {
      this.handleEndOfData.emit(++this.page);
      this.isUpdateDataRequestSent = true;
    }
  }
}
